import React from 'react'

import clsxm from '@/lib/clsxm'

import WrapperStyles from './Wrapper.module.css'

interface WrapperProps {
  className?: string
  children?: React.ReactNode
}

function Wrapper({ children, className }: WrapperProps): JSX.Element {
  const classes = [WrapperStyles['hn-wrapper']]
  if (className) classes.push(className)

  return (
    <>
      <div id='main-section' className={clsxm(classes, className)}>
        {children}
      </div>
    </>
  )
}
export default Wrapper
